import { TYPES } from "./setting_withdraw.type";
import { onSnapshot, doc } from "firebase/firestore";
//func
import { getRefs } from "../ref";

// ========= firebase function =========//

//snap all provider
const allSettingWithdrawSub = [];
export const snapSettingWithdraw = (callback) => (dispatch) => {
  setSettingWithdrawAllSuccess(dispatch, null);
  const cRef = getRefs().setting;
  const id = "withdraw";
  const dRef = doc(cRef, id);
  const unsub = onSnapshot(dRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.data();
      console.log("snap setting:" + JSON.stringify(data));
      setSettingWithdrawAllSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allSettingWithdrawSub.push(unsub);
};

export const unSnapSettingWithdraw = () => (dispatch) => {
  allSettingWithdrawSub.forEach((subscriber) => {
    subscriber();
  });
  allSettingWithdrawSub.length = 0;
};
// ========= cloud function =========//
// ========= local function =========//
export const setSettingWithdrawAll = (data, callback) => (dispatch) => {
  setSettingWithdrawAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};
// ========= dispatch =========//

const setSettingWithdrawAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_SETTING_WITHDRAW_ALL,
    payload: data,
  });
};
